import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { ReviewAndSubmitAddendumForm } from '../forms'
import { useHistory, Redirect } from 'react-router-dom'
import { Path } from 'config/portal'
import { TOAST_ERROR_CONTACT_SUPPORT } from 'config/notifications'
import * as apiActions from 'api-actions'
import * as productActions from '../../products/actions'
import { selectors as globalSelectors } from 'global-reducer'
import { flashErrorMessage } from 'redux-flash'
import { selectors as selectors } from '../reducer'
import { selectors as productSelectors } from '../../products/reducer'
import { isEmpty } from 'lodash'
import { ProductAgreementType } from 'config/products'

const propTypes = {
  currentUser: Types.user.isRequired,
  addendumServicesAgreementHash: PropTypes.object.isRequired,
  submitAddendumServicesAgreementForm: PropTypes.func.isRequired,
  setShouldTriggerAllServicesAgreementsFetch: PropTypes.func.isRequired,
  setShouldTriggerAllBDPlanAgreementsFetch: PropTypes.func.isRequired,
  setShouldTriggerAllNotificationsPlanAgreementsFetch:
    PropTypes.func.isRequired,
  flashErrorMessageHandler: PropTypes.func.isRequired,
}

const defaultProps = {}

function ReviewAndSubmitAddendumView({
  currentUser,
  submitAddendumServicesAgreementForm,
  setShouldTriggerAllServicesAgreementsFetch,
  setShouldTriggerAllBDPlanAgreementsFetch,
  setShouldTriggerAllNotificationsPlanAgreementsFetch,
  flashErrorMessageHandler,
  addendumServicesAgreementHash,
}) {
  const history = useHistory()

  const addendumAgreement = addendumServicesAgreementHash

  const handleSubmit = async () => {
    try {
      await submitAddendumServicesAgreementForm({
        signerEmail: currentUser.userEmail,
        signerTitle: currentUser.userTitle,
        addendumStatus: 'Signed',
        signerName: currentUser.firstName,
        serviceAgreementId: addendumAgreement.value,
        signingMethod: 'E-Sign RSP',
        portalAddendumType: ProductAgreementType.NOTIFICATIONS,
      })
      setShouldTriggerAllServicesAgreementsFetch(true)
      setShouldTriggerAllBDPlanAgreementsFetch(true)
      setShouldTriggerAllNotificationsPlanAgreementsFetch(true)
      history.push({
        pathname: Path.NOTIFICATIONS_HISTORY,
        state: {
          ignorePrompt: true, // No need to warn the user about leaving the flow
          showNotificationsAddendumSuccessModal: true,
        },
      })
    } catch (error) {
      flashErrorMessageHandler(TOAST_ERROR_CONTACT_SUPPORT)
    }
  }

  if (isEmpty(addendumServicesAgreementHash))
    return <Redirect to={Path.ADD_NEW_NOTIFICATIONS_ADDENDUM} />

  return (
    <div className="card full-height complete-search-agreement-view">
      <div className="complete-search-agreement-form-container">
        <div className="form-masthead">
          <h2>Next, review and agree to the addendum details</h2>
        </div>
        <div className="form-section">
          <ReviewAndSubmitAddendumForm
            initialValues={{
              confirm: false,
              dialogRead: false,
            }}
            onSubmit={handleSubmit}
            userDetails={{
              firstName: currentUser.firstName,
              lastName: currentUser.lastName,
              title: currentUser.userTitle,
              phone: currentUser.accountPhone,
              email: currentUser.userEmail,
            }}
          />
        </div>
      </div>
    </div>
  )
}

ReviewAndSubmitAddendumView.propTypes = propTypes
ReviewAndSubmitAddendumView.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    currentUser: globalSelectors.currentUser(state),
    shouldTriggerAllServicesAgreementsFetch:
      productSelectors.shouldTriggerAllServicesAgreementsFetch(state),
    servicesAgreements: productSelectors.servicesAgreements(state),
    addendumServicesAgreementHash:
      selectors.addendumServicesAgreementHash(state),
  }
}

const mapDispatchToProps = {
  submitAddendumServicesAgreementForm:
    apiActions.submitAddendumServicesAgreementForm,
  setShouldTriggerAllServicesAgreementsFetch:
    productActions.setShouldTriggerAllServicesAgreementsFetch,
  setShouldTriggerAllBDPlanAgreementsFetch:
    productActions.setShouldTriggerAllBDPlanAgreementsFetch,
  setShouldTriggerAllNotificationsPlanAgreementsFetch:
    productActions.setShouldTriggerAllNotificationsPlanAgreementsFetch,
  flashErrorMessageHandler: flashErrorMessage,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ReviewAndSubmitAddendumView)
)
